/** @format */
import { HTMLProps, ReactNode } from 'react';

export enum CustomSelectAlignment {
    LEFT = 'left',
    RIGHT = 'right',
}

export type CustomSelectProps = Pick<
    HTMLProps<HTMLButtonElement>,
    'className'
> & {
    children: ReactNode;
    'data-testid'?: string;
    closeMenuAriaLabel?: string;
    openMenuAriaLabel?: string;
    label?: string;
    isActive?: boolean;
    isOpen?: boolean;
    onToggleOpen?: () => void;

    /**
     * Handler for when the user clicks outside of the custom select
     */
    onClickOut?: () => void;

    /**
     * The html element ID, must be unique
     */
    id: string;
};

export type CustomSelectSkeletonProps = Pick<
    CustomSelectProps,
    'data-testid' | 'className' | 'isOpen' | 'isActive'
>;

export type StyledCustomSelectProps = Pick<
    CustomSelectProps,
    'isOpen' | 'isActive'
> & {
    alignment: CustomSelectAlignment;
};
